var map = {
	"./A_brighter_Muskoka_with IRIS_&_Muskoka _Futures.mp4": 9994,
	"./Good Roads Conference Demo Video.mp4": 1502,
	"./IRIS Digital Twins & Video Analytics Product Suite.mp4": 9424,
	"./Website teaser - irisCITY demo from Roving irisGO™ at City of Vaughan.mp4": 4631,
	"./building_smart_roads_automated_pavement_right_of_way_and_asset_management_data_collection_360p.mp4": 3188,
	"./isircity_demo.mp4": 3036,
	"./privacy.mp4": 3849,
	"./street_demo.mp4": 9843,
	"./toronto_5g_demo.mp4": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4783;